import { useQuery } from '@tanstack/react-query';

import { entitlementsApi } from '@/api/entitlements';

export const ENTITLEMENTS_QUERY_KEY = ['entitlements'] as const;

export function useEntitlements(options: { enabled?: boolean } = {}) {
    const query = useQuery({
        queryKey: ENTITLEMENTS_QUERY_KEY,
        queryFn: entitlementsApi.getEntitlements,
        enabled: options.enabled ?? true,
        staleTime: 30_000,
    });

    return {
        entitlements: query.data,
        features: query.data?.features ?? {},
        plan: query.data?.plan,
        status: query.data?.status,
        active: query.data?.active ?? false,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isError: query.isError,
        error: query.error,
        refetch: query.refetch,
    };
}
